import React, { Component } from 'react';

import ScrollupSection from '../components/scrollupSection/scrollUp';
import Header from '../components/welcomeSection/header';
import Games from '../components/aboutSection/games';
import FooterSection from '../components/footerSection/footer';
import InstagramPost from '../components/aboutSection/instagramPost';

class Landing extends Component {
    render() {
        return (
            <div className="miami">
                <ScrollupSection />
                <div className="all-area">
                    <Header />
                    <Games />
                    <InstagramPost link="https://www.instagram.com/reel/DPPBc30kduJ/" />
                    <InstagramPost link="https://www.instagram.com/reel/DPHgFqij1nb/" />
                    <InstagramPost link="https://www.instagram.com/reel/DJr3EVxvLgf/" />
                    <InstagramPost link="https://www.instagram.com/reel/DKI58sLxmsY/" />
                    <FooterSection />
                </div>
            </div>
        );
    }
}

export default Landing;